import ProjectPage from './ProjectPage';

export default ProjectPage;
